module.exports = __webpack_public_path__ + "img/about.5861f377.svg";